import SiteService from "./SiteService";

const HarbourService = {
	getAll: async function(cb) {
		try {
			const response = await fetch(
				`${SiteService.apiPath}/admin/getharbourpage`,
				{
					method: "POST",
					body: JSON.stringify({
						pageOptions: { page: 0 }
					}),
					headers: { 'Content-Type': 'application/json' }
				}
			);
			const data = await response.json();

			if (cb)
				cb(data);
			else
				return data;
		} catch (reason) {
			console.error(reason);
			alert('Feil under henting av spesifikasjoner');
		}
	},

	getPage: function(pageNumber, sortBy, searchObj, limit, cb){
		fetch(
			`${SiteService.apiPath}/admin/getharbourpage`,
			{
				method: "POST",
				body: JSON.stringify({
					pageOptions: {page: pageNumber, sortBy: sortBy, searchObj: searchObj, limit: limit}
				}),
				headers: {'Content-Type': 'application/json'}
			}
		).then((response)=> {
			return response.json();
		})
			.then((data)=> {
				if(cb) cb(data);
			})
			.catch(reason => {
				console.error(reason);
				alert('Feil under henting av havn');
			})
	},

	create: function(author, cb){
		return alert('funksjon ikke implementert');
	},

	save: ()=>{
		return alert('funksjon ikke implementert');
	},

	delete: async (_id) => {try {
		if(!confirm('Er du sikker på at du vil slette spesifikasjonen?')) return false;
		const req = await fetch(`${SiteService.apiPath}/harbour/${_id}`, {
			method: "DELETE",
		});
		if (req.ok) {
			return true;
		} else {
			alert('Feil under sletting av havn');
			return false;
		}
	} catch (reason) {
		console.error(reason);
		alert('Feil under sletting av havn');
	}},

	saveCreate: async function(formData){try {
		const req = await fetch(`${SiteService.apiPath}/harbour/${formData._id?formData._id:''}`, {
			method: "POST",
			body: JSON.stringify(formData),
			headers: {'Content-Type': 'application/json'}
		});
		if (req.ok) {
			//handle returned json data
			let data = await req.json();
			return data;
		}
		else {
			alert('Feil under lagring av havn');
			return false;
		}
	} catch (reason) {
		console.error(reason);
		alert('Feil under lagring av havn');
	}},
}

export default HarbourService;